import React, { useState } from "react";
import { Box } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import { Typography, Input, Divider, Link, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import linkedin from "../icons/linkedin.svg";
import instagram from "../icons/instagram.svg";
import instagramGreen from "../icons/instagram-green.svg";
import facebookGreen from "../icons/facebook-green.svg";
import linkedinGreen from "../icons/linkedin-green.svg";
import twitterGreen from "../icons/twitter-green.svg";

import facebook from "../icons/facebook.svg";
import youtube from "../icons/youtube.svg";
import twitter from "../icons/twitter.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { postFooterForm } from "src/api/APIs";
import Notibar from "src/utils/Notibar";
import { makeStyles } from "@material-ui/core";
import goToTop from "../icons/go-to-top.svg";
const Footer = () => {
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");
  const [email, setEmail] = useState("");
  const [overInsta, setOverInsta] = useState(false);
  const [overTwitter, setOverTwitter] = useState(false);
  const [overLinked, setOverLinked] = useState(false);
  const [overFacebook, setOverFacebook] = useState(false);
  const classes = useStyles();
  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: theme.palette.secondary.main,
    whiteSpace: "nowrap",
  }));

  const handleSubmit = async () => {
    await postFooterForm(email)
      .then(() => {
        setEmail("");
        Notibar.success(
          "Thank you! You are now subscribed to receive updates from BKV energy."
        );
      })
      .catch((error) => {
        Notibar.error(error);
      });
  };

  return (
    <Box
      sx={{
        background: theme.palette.primary.main,
        padding: {
          xs: "95px 30px 160px 30px",
          sm: "95px 30px 160px 30px",
          md: "95px 60px 160px 60px",
          lg: "120px",
          xxl: "70px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          },
          justifyContent: "space-between",
          //marginBottom: "1%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            marginBottom: { xs: "20%", sm: "20%", md: "20%", lg: "0" },
          }}
        >
          <Typography
            fontSize={{ xs: "30px", sm: "30px", md: "30px", lg: "30px" }}
            color={theme.palette.mustard.main}
            fontWeight={400}
            variant="body2"
            mb={{ xs: "20px", lg: "0" }}
          >
            Questions?
          </Typography>
          <Link underline="none" href="tel:18552584797">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
              }}
            >
              <Typography
                fontSize={{ xs: "26px", sm: "26px", md: "45px", lg: "50px" }}
                color={theme.palette.white.main}
                // mt="5%"
                variant="body2"
                sx={{
                  "&: hover": {
                    color: "#87c674",
                  },
                }}
              >
                1 855 PWR TXAS
              </Typography>
              <Typography
                variant="body1"
                color="#84a8bf"
                fontSize={{ xs: "18px", sm: "18px", md: "25px", lg: "25px" }}
                ml="10px"
                fontWeight="600"
                sx={{
                  "&: hover": {
                    color: "#87c674",
                  },
                }}
              >
                (258-4797)
              </Typography>
            </Box>
          </Link>
          <Link underline="none" href="mailto:info@bkvenergy.com">
            <Typography
              fontSize={{ xs: "26px", sm: "26px", md: "45px", lg: "50px" }}
              color={theme.palette.white.main}
              variant="body2"
              sx={{
                "&: hover": {
                  color: "#87c674",
                },
              }}
            >
              bkvenergy.com
            </Typography>
          </Link>
        </Box>
        <Box
          marginBottom={{ xs: "15%", sm: "15%", md: "0", lg: "0" }}
          width={{ xs: "100%", sm: "100%", md: "100%", lg: "40%" }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography
            fontSize={{ xs: "30px", sm: "30px", md: "30px", lg: "50px" }}
            color={theme.palette.mustard.main}
            fontWeight={400}
            variant="body2"
            mb="5%"
            whiteSpace="nowrap"
          >
            Keep me in the loop
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
            mb="10%"
          >
            <TextField
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              placeholder="e-mail"
              sx={{
                borderBottom: 0,
                color: theme.palette.primary.main,
                background: "#ededed",
                borderRadius: "9vw",
                width: "60%",
                marginRight: "20px",
                // width: {
                //   xs: "60%",
                //   sm: "60%",
                //   md: "70%",
                //   lg: "60%",
                //   xl: "70%",
                // },
                padding: {
                  xs: "7px 44px",
                  sm: "7px 44px",
                  md: "10px 44px",
                  lg: "16px 37px",
                },
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true,
              }}
            />
            <Button
              onClick={handleSubmit}
              className={classes.button}
              sx={{
                padding: {
                  xs: "3px 44px",
                  sm: "3px 44px",
                  md: "10px 85px",
                  lg: "16px 37px",
                },
                width: "40%",
              }}
              type="submit"
            >
              <Typography
                fontSize={{
                  xs: "10px",
                  md: "3vw",
                  lg: "15px",
                }}
                sx={{ lineHeight: "21px", fontWeight: "1000" }}
                color="#fff"
              >
                SIGN UP
              </Typography>
            </Button>
          </Box>

          <Typography
            color={theme.palette.mustard.main}
            fontWeight={600}
            fontSize={{ xs: "16px", sm: "16px", md: "16px", lg: "16px" }}
            variant="body1"
            mb="6%"
          >
            Follow Us
          </Typography>
          <Box
            mb="7%"
            sx={{
              display: "flex",
              flexDirection: "row",
              // justifyContent: "space-between",
              alignItems: "center",
            }}
            width="100%"
          >
            <Box
              width={{ xs: "10%", sm: "10%", md: "4%", lg: "27px" }}
              mr={{ xs: "10%", sm: "10%", md: "3%", lg: "30px" }}
            >
              <Link
                underline="none"
                href="https://www.linkedin.com/company/bkvenergy"
              >
                <img
                  onMouseOver={() => setOverLinked(true)}
                  onMouseOut={() => setOverLinked(false)}
                  width="100%"
                  src={overLinked ? linkedinGreen : linkedin}
                />
              </Link>
            </Box>
            <Box
              width={{ xs: "10%", sm: "10%", md: "4%", lg: "27px" }}
              mr={{ xs: "10%", sm: "10%", md: "3%", lg: "30px" }}
            >
              <Link underline="none" href="https://twitter.com/bkvenergy">
                <img
                  onMouseOver={() => setOverTwitter(true)}
                  onMouseOut={() => setOverTwitter(false)}
                  width="100%"
                  src={overTwitter ? twitterGreen : twitter}
                />
              </Link>
            </Box>
            <Box
              width={{ xs: "10%", sm: "10%", md: "4%", lg: "27px" }}
              mr={{ xs: "10%", sm: "10%", md: "3%", lg: "30px" }}
            >
              <Link
                underline="none"
                href="https://www.instagram.com/bkvenergy/"
              >
                <img
                  onMouseOver={() => setOverInsta(true)}
                  onMouseOut={() => setOverInsta(false)}
                  width="100%"
                  src={overInsta ? instagramGreen : instagram}
                />
              </Link>
            </Box>
            <Box
              width={{ xs: "10%", sm: "10%", md: "4%", lg: "27px" }}
              mr={{ xs: "10%", sm: "10%", md: "3%", lg: "30px" }}
            >
              <Link underline="none" href="https://www.facebook.com/BKVEnergy">
                <img
                  onMouseOver={() => setOverFacebook(true)}
                  onMouseOut={() => setOverFacebook(false)}
                  width="100%"
                  src={overFacebook ? facebookGreen : facebook}
                />
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ bgcolor: theme.palette.secondary.main }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          marginTop: "3%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "column",
              lg: "column",
              xl: "column",
              xxl: "row",
            },
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                xxl: "35%",
              },
            }}
            mb="2%"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "50%",
              }}
            >
              <Link underline="none" href="https://bkvenergy.com/about-us/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#ffd27d",
                    fontWeight: "700",
                    marginBottom: "8%",
                  }}
                >
                  About Us
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/about-us/#whyBKV"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Why BKVE
                </Typography>
              </Link>
              <Link underline="none" href="https://bkvenergy.com/blog/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Blog
                </Typography>
              </Link>
              <Link underline="none" href="https://bkvenergy.com/newsroom/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Newsroom
                </Typography>
              </Link>
              <Link underline="none" href="https://bkvenergy.com/media-assets/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Media Assets
                </Typography>
              </Link>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "50%",
              }}
            >
              <Link underline="none" href="https://bkvenergy.com/support/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#ffd27d",
                    fontWeight: "700",
                    marginBottom: "8%",
                  }}
                >
                  Contact
                </Typography>
              </Link>
              <Link underline="none" href="https://bkvenergy.com/support/#faqs">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  FAQs
                </Typography>
              </Link>
              <Link underline="none" href="https://bkvenergy.com/outage/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Outages
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/support-center/what-are-tdsp-charges/"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  TDU Pass-Through Charges
                </Typography>
              </Link>
              <Link underline="none" href="https://bkvenergy.com/sitemap/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Sitemap
                </Typography>
              </Link>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                xxl: "65%",
              },
              flexDirection: { xs: "column", lg: "row" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "100%",
                  lg: "50%",
                  xl: "50%",
                  xxl: "40%",
                },
                marginBottom: "2%",
              }}
            >
              <Link underline="none" href="https://bkvenergy.com/support/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#ffd27d",
                    fontWeight: "700",
                    marginBottom: "6%",
                  }}
                >
                  Support Center
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/support-center/your-rights/"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Your Rights
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/support-center/payment-plans-and-waiver-program/"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Payment Plans and Waiver Program
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/support-center/payment-assistance-programs/"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Payment Assistance Programs
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/support-center/cancellation-notice/"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Cancellation Notice
                </Typography>
              </Link>
              <Link
                underline="none"
                href="https://bkvenergy.com/support-center/transfer-of-service/"
              >
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#fff",
                    marginBottom: "2%",
                    fontWeight: "400",
                  }}
                >
                  Transfer Your Service
                </Typography>
              </Link>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "100%",
                  lg: "50%",
                  xl: "50%",
                  xxl: "60%",
                },
              }}
            >
              <Link underline="none" href="https://bkvenergy.com/support/">
                <Typography
                  className={classes.links}
                  sx={{
                    fontSize: "16px",
                    color: "#ffd27d",
                    fontWeight: "700",
                    marginBottom: "6%",
                  }}
                >
                  Service Areas
                </Typography>
              </Link>
              <Box
                width="100%"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box width="33%">
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-houston"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Houston
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-arlington"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Arlington
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-laredo"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Laredo
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-frisco"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Frisco
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      See All...
                    </Typography>
                  </Link>
                </Box>
                <Box width="33%">
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-dallas"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Dallas
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-corpus-christi"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Corpus Christi
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-irving"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Irving
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-pasadena"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Pasadena
                    </Typography>
                  </Link>
                </Box>
                <Box width="33%">
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-fort-worth"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Fort Worth
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-plano"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Plano
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-grand-prairie"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Grand Prairie
                    </Typography>
                  </Link>
                  <Link
                    underline="none"
                    href="https://bkvenergy.com/find-power/electricity-provider-in-mesquite"
                  >
                    <Typography
                      className={classes.links}
                      sx={{
                        fontSize: "16px",
                        color: "#fff",
                        marginBottom: "2%",
                        fontWeight: "400",
                      }}
                    >
                      Mesquite
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box width={{ xs: "50%", lg: "100%" }}>
            <Typography
              color="#84a8bf"
              fontSize={{ xs: "10px", sm: "10px", lg: "14px" }}
            >
              PUCT#: 10323 |{" "}
              <Link
                underline="none"
                color="#84a8bf"
                href="https://bkvenergy.com/terms-of-use/"
                className={classes.footerLinks}
              >
                Terms of Use
              </Link>{" "}
              |{" "}
              <Link
                underline="none"
                color="#84a8bf"
                href="https://bkvenergy.com/privacy-policy/"
                className={classes.footerLinks}
              >
                Privacy Policy
              </Link>{" "}
              |{" "}
              <Link
                underline="none"
                color="#84a8bf"
                href="https://bkvenergy.com/support-center/your-rights/"
                className={classes.footerLinks}
              >
                Your Rights as a Customer (YRAC)
              </Link>
            </Typography>
            <Typography
              fontSize={{ xs: "10px", sm: "10px", lg: "14px" }}
              color="#84a8bf"
            >
              4800 Blue Mound Road, Fort Worth, TX 76106; Phone:{" "}
              <Link
                underline="none"
                color="#84a8bf"
                href="tel:18552584797"
                className={classes.footerLinks}
              >
                1-855-BKVE-4PWR
              </Link>
            </Typography>
          </Box>

          <Box
            onClick={() => {
              document.getElementById("header").scrollIntoView();
            }}
            width={{ xs: "30%", lg: "15%", xxl: "12%" }}
            sx={{ alignItems: "flex-end", cursor: "pointer" }}
          >
            <img src={goToTop} width="100%" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #009A88",
    "&:hover": {
      background: "transparent",
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      color: "#009A88",
    },
  },
  image: {
    "&:hover": {
      content: `url(../icons/instagram-green.svg)`,
    },
  },
  links: {
    "&:hover": {
      color: "#00b49d",
    },
  },
  footerLinks: {
    "&:hover": {
      color: "#00b49d",
    },
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
